import { useEffect, useState } from "react";
import { RightBar } from "../../../../ui/organisms/rightBar";
import { GlobalGapCoCList } from "./list";
import { GlobalGapCoCRight } from "./right";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { resetLotCreationStatus, resetTabUpdateStatus } from "./slice";

export function GlobalGapCoC() {
    const dispatch = useAppDispatch()
    const ggnotificationCoCState = useAppSelector(state => state.ggNotificationCoC)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (ggnotificationCoCState.tabUpdateStatus === 'successfully') {
            dispatch(resetTabUpdateStatus())
            setShowSuccess(true)
        }
    }, [ggnotificationCoCState.tabUpdateStatus])

    useEffect(() => {
        if (ggnotificationCoCState.lotCreationStatus === 'successfully') {
            setShowSuccess(true)
        }
    }, [ggnotificationCoCState.lotCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: '0.7' }}>
                {
                    (showSuccess) &&

                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Dati salvati correttamente.
                        </span>
                    </div>
                }
                <GlobalGapCoCList />
            </div>
            <div style={{ flex: '0.3' }}>
                <RightBar>
                    <GlobalGapCoCRight />
                </RightBar>
            </div>
        </div>
    )
}